import React from "react";

export default function CurrentCity(props) {
  return <div className="col-4 currentCity">{props.currentCity}</div>;
}
